import { useMutation } from "react-query";
import { createFamilyMedicalHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useCreateFamilyMedicalHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      createFamilyMedicalHistory(clientId, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while saving the family medical history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    createFamilyMedicalHistoryMutation: mutate,
    isCreateFamilyMedicalHistoryLoading: isLoading,
    ...rest,
  };
};

export default useCreateFamilyMedicalHistory;
